import * as React from 'react'
import * as PropTypes from 'prop-types'

import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import { DataTypeProvider } from '@devexpress/dx-react-grid'

import withFirebase from '../../withFirebase'

const styles = {
  numericInput: {
    textAlign: 'right',
    width: '100%'
  }
}

const Formatter = withFirebase(({ firebase, value }) => {
  // console.log(value)
  return (
    <IconButton
      disabled={!value}
      onClick={() => {
        const storage = firebase.storage()
        const pathReference = storage.ref(value.fullPath)
        pathReference
          .getDownloadURL()
          .then(function(url) {
            // `url` is the download URL for 'images/stars.jpg'
            // This can be downloaded directly:
            var xhr = new XMLHttpRequest()
            xhr.responseType = 'blob'
            xhr.onload = function(event) {
              const blob = xhr.response
              const a = document.createElement('a')
              a.href = window.URL.createObjectURL(blob)
              a.download = `${value.name}.pdf`
              a.click()
            }
            xhr.open('GET', url)
            xhr.send()
          })
          .catch(console.error)
      }}>
      <Icon fontSize="small">cloud_download</Icon>
    </IconButton>
  )
})

const EditorBase = ({ value, onValueChange, classes }) => {
  const handleChange = ({ target: { files } }) => {
    if (files.length === '') {
      onValueChange()
      return
    }
    onValueChange(files[0])
  }
  return (
    <label>
      <input
        id="upload"
        type="file"
        accept="application/pdf"
        style={{ display: 'none' }}
        onChange={handleChange}
        onBlur={handleChange}
      />
      <IconButton component="span">
        <Icon>attachment</Icon>
      </IconButton>
    </label>
  )
}

EditorBase.propTypes = {
  value: PropTypes.object,
  onValueChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

EditorBase.defaultProps = {
  value: undefined
}

const Editor = withStyles(styles)(EditorBase)

const availableFilterOperations = [
  'equal',
  'notEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'lessThan',
  'lessThanOrEqual'
]

const DateTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={Formatter}
    editorComponent={Editor}
    availableFilterOperations={availableFilterOperations}
    {...props}
  />
)

export default DateTypeProvider
